/* CR - "Alle merken" link rechtsboven in de SHOP BRANDS-secties (home + collectie),
   gestyled als de "Shop all"-link, verwijst naar de merkenpagina. */
(function () {
  if (window.__crBrandsLink) return;
  window.__crBrandsLink = true;

  var HREF = '/pages/merken';
  var LABEL = 'Alle merken';

  function align(link, head, c) {
    var hr = head.getBoundingClientRect(), cr = c.getBoundingClientRect();
    link.style.top = Math.round(hr.top - cr.top + hr.height / 2 - link.offsetHeight / 2) + 'px';
  }

  function init() {
    var containers = document.querySelectorAll('[class*="ai-brand-showcase__container"]');
    containers.forEach(function (c) {
      if (c.querySelector('.cr-brands-alllink')) return;
      var head = c.querySelector('[class*="ai-brand-showcase__heading"]');
      if (!head) return;
      var link = document.createElement('a');
      link.href = HREF;
      link.className = 'cr-brands-alllink';
      link.textContent = LABEL;
      c.style.position = 'relative';
      c.appendChild(link);
      align(link, head, c);
      window.addEventListener('resize', function () { align(link, head, c); });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
